import React from 'react';
import { Card } from '../../../_shared/components/Card/Card';
import { Typography } from '../../../_shared/components/Typography/Typography';
import { StatusLabel } from '../../../_shared/components/StatusLabel/StatusLabel';
import styles from './CardEfficiency.module.scss';

export function CardEfficiency({ number, title, content, statusName, status }) {
  return (
    <>
      <Card>
        <div className={styles.block}>
          <Typography variant={'h1'} className={styles.grey}>
            {number}
          </Typography>
          <div className={styles.textBlock}>
            <Typography variant={'h3'} className={styles.grey}>
              {title}
            </Typography>
            <Typography variant={'text'}>{content}</Typography>
            {status && (
              <StatusLabel
                variant={
                  status === 'success'
                    ? 'success'
                    : status === 'error'
                    ? 'error'
                    : 'info'
                }
                className={styles.status}
              >
                {statusName}
              </StatusLabel>
            )}
          </div>
        </div>
      </Card>
    </>
  );
}
